module.exports = __webpack_public_path__ + "static/media/Saff.6ec71a24.png";